import Ordering from '@/common/constants/ordering.constants';
import semver from 'semver';

export function versionSorter(a, b) {
  if (semver.lt(a.version, b.version)) return Ordering.Less;
  if (semver.gt(a.version, b.version)) return Ordering.Greater;
  if (a.release > b.release) return Ordering.Greater;
  if (a.release < b.release) return Ordering.Less;

  return Ordering.Equal;
}

export default versionSorter;
